import React, { useEffect } from "react";
import BtnToAction from "./BtnToAction.module";
import { useFetchWithToken } from "../../FetchWithToken/FetchWithToken";
import { AuthContext } from "../../../Constants/AuthProvider";
import { apiUrl } from "../../../Constants/Constants";
const ConfigDownload = ({ item, loadingShower }) => {
  const { onLogout } = React.useContext(AuthContext);
  const { loading, fetchWithToken } = useFetchWithToken();
  useEffect(() => {
    loadingShower(loading);
  }, [loading]);
  const generateUniqueFileName = (baseName) => {
    const randomNumber = Math.floor(Math.random() * 100); // تولید عدد تصادفی بین 0 و 99
    const truncatedName = baseName.slice(0, 7); // محدود کردن نام به 7 کاراکتر
    return `${truncatedName}${randomNumber}`; // ترکیب نام کوتاه‌شده با عدد تصادفی
  };
  const downloadConfig = async () => {
    try {
      const blob = await fetchWithToken(
        apiUrl + "user/create-config",
        {
          method: "POST",
        },

        JSON.stringify({ accountid: item.contain.containid })
      );

      if (blob instanceof Blob) {
        // ایجاد لینک دانلود برای فایل
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          generateUniqueFileName(item.accountName) +
            (item.type == "Ovpn" || item.type == "Ovpns" ? ".ovpn" : ".conf")
        ); // نام فایل
        document.body.appendChild(link);
        link.click();
        link.remove();
        if (blob.status === "401") {
          onLogout();
        }
      }
    } catch (error) {
      console.error("خطا در دانلود فایل:", error);
    }
  };
  return (
    <BtnToAction
      icon="fa-solid fa-arrow-down-to-line"
      action={() => downloadConfig()}
    >
      دانلود کانفیگ
    </BtnToAction>
  );
};

export default ConfigDownload;
